// Helper for creating collision-free Supabase Realtime channel topics.
//
// WHY THIS EXISTS
// supabase's `client.channel(topic)` RETURNS AN ALREADY-EXISTING channel when a
// channel with that topic is still registered. Calling
// `.on('postgres_changes', …)` on a channel that has already been subscribed
// throws:
//
//   Uncaught Error: cannot add postgres_changes callbacks for
//   realtime:<topic> after subscribe()
//
// which is an *uncaught* error inside a React effect — it takes down the whole
// render tree, not just the widget.
//
// A fixed topic like `comments:${appointmentId}` collides in two real ways:
//   1. Two components subscribing to the same record at once (e.g. an unseen
//      badge plus the panel that shows the same comments).
//   2. A remount before cleanup finished — `removeChannel()` is async (it
//      awaits `unsubscribe()`), so route changes re-enter the effect while the
//      previous channel is still registered.
//
// Giving every subscriber its own topic removes both. Realtime delivers the
// same postgres_changes payloads to each channel independently, so separate
// topics do not change behaviour — they only avoid the shared-object clash.

let seq = 0;

/**
 * Build a process-unique realtime topic.
 * @param {string} base e.g. `comments:${appointmentId}`
 * @returns {string} `${base}:${n}` — stable for the caller, unique per call.
 */
export function uniqueChannelTopic(base) {
  seq += 1;
  return `${base}:${seq}`;
}
